// extracted by mini-css-extract-plugin
export default {"container":"RrB4nb","tablist":"_3UBgeY","tab":"_1SXylo","selected":"_2gxLAy","tabpannel":"_14QDks","selectedTabPanel":"_3XSXE0"};